import * as React from 'react';
import tombacIcon from '../tombacIcon';

function SvgUnlock(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="5 0 14 24" {...props}>
      <path
        d="M12 2a5 5 0 015 5v2h.25c.912 0 1.667.635 1.744 1.436l.006.135v7.858c0 .818-.707 1.496-1.6 1.565l-.15.006H6.75c-.912 0-1.667-.635-1.744-1.436L5 18.429V10.57c0-.818.707-1.496 1.6-1.565L6.75 9H15V7a3 3 0 10-6 0H7a5 5 0 015-5z"
        fill="currentColor"
      />
    </svg>
  );
}

export default tombacIcon('Unlock')(SvgUnlock);
